<template>
  <div class="top-small relative w-full align-middle content-center">
    <div class="absolute top-0 left-0">
      <slot name="left"></slot>
    </div>
    <slot name="default"></slot>
    <div class="absolute top-0 right-0 h-full z-10">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopSmall"
};
</script>

<style lang="scss" scoped>
.top-small {
  height: 1.736rem;
  flex: 0 0 1.736rem;
}

.top-small /deep/ .tutorial-button {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

@media (min-width: 768px) {
  .top-small {
    height: 1.984rem;
    flex: 0 0 1.984rem;
  }
}
</style>
